/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PutSalesforceSettingSyncSfObjectRequest } from '../models';
/**
 * SalesforceSettingsApi - axios parameter creator
 * @export
 */
export const SalesforceSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * SFリード連携更新API
         * @summary SFリード連携更新API
         * @param {PutSalesforceSettingSyncSfObjectRequest} [putSalesforceSettingSyncSfObjectRequest] SFリード連携更新APIのリクエストボディ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSalesforceSettingSyncSfObject: async (putSalesforceSettingSyncSfObjectRequest?: PutSalesforceSettingSyncSfObjectRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/salesforce/salesforce_settings/update_sync_sf_object`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putSalesforceSettingSyncSfObjectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SalesforceSettingsApi - functional programming interface
 * @export
 */
export const SalesforceSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SalesforceSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * SFリード連携更新API
         * @summary SFリード連携更新API
         * @param {PutSalesforceSettingSyncSfObjectRequest} [putSalesforceSettingSyncSfObjectRequest] SFリード連携更新APIのリクエストボディ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putSalesforceSettingSyncSfObject(putSalesforceSettingSyncSfObjectRequest?: PutSalesforceSettingSyncSfObjectRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putSalesforceSettingSyncSfObject(putSalesforceSettingSyncSfObjectRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SalesforceSettingsApi - factory interface
 * @export
 */
export const SalesforceSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SalesforceSettingsApiFp(configuration)
    return {
        /**
         * SFリード連携更新API
         * @summary SFリード連携更新API
         * @param {PutSalesforceSettingSyncSfObjectRequest} [putSalesforceSettingSyncSfObjectRequest] SFリード連携更新APIのリクエストボディ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSalesforceSettingSyncSfObject(putSalesforceSettingSyncSfObjectRequest?: PutSalesforceSettingSyncSfObjectRequest, options?: any): AxiosPromise<void> {
            return localVarFp.putSalesforceSettingSyncSfObject(putSalesforceSettingSyncSfObjectRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SalesforceSettingsApi - interface
 * @export
 * @interface SalesforceSettingsApi
 */
export interface SalesforceSettingsApiInterface {
    /**
     * SFリード連携更新API
     * @summary SFリード連携更新API
     * @param {PutSalesforceSettingSyncSfObjectRequest} [putSalesforceSettingSyncSfObjectRequest] SFリード連携更新APIのリクエストボディ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceSettingsApiInterface
     */
    putSalesforceSettingSyncSfObject(putSalesforceSettingSyncSfObjectRequest?: PutSalesforceSettingSyncSfObjectRequest, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for putSalesforceSettingSyncSfObject operation in SalesforceSettingsApi.
 * @export
 * @interface SalesforceSettingsApiPutSalesforceSettingSyncSfObjectRequest
 */
export interface SalesforceSettingsApiPutSalesforceSettingSyncSfObjectRequest {
    /**
     * SFリード連携更新APIのリクエストボディ
     * @type {PutSalesforceSettingSyncSfObjectRequest}
     * @memberof SalesforceSettingsApiPutSalesforceSettingSyncSfObject
     */
    readonly putSalesforceSettingSyncSfObjectRequest?: PutSalesforceSettingSyncSfObjectRequest
}

/**
 * SalesforceSettingsApi - object-oriented interface
 * @export
 * @class SalesforceSettingsApi
 * @extends {BaseAPI}
 */
export class SalesforceSettingsApi extends BaseAPI implements SalesforceSettingsApiInterface {
    /**
     * SFリード連携更新API
     * @summary SFリード連携更新API
     * @param {SalesforceSettingsApiPutSalesforceSettingSyncSfObjectRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SalesforceSettingsApi
     */
    public putSalesforceSettingSyncSfObject(requestParameters: SalesforceSettingsApiPutSalesforceSettingSyncSfObjectRequest = {}, options?: AxiosRequestConfig) {
        return SalesforceSettingsApiFp(this.configuration).putSalesforceSettingSyncSfObject(requestParameters.putSalesforceSettingSyncSfObjectRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
